<template>
  <div>
    <div class="subject-group" v-if="!addOrDelTopicDialogVisible">
      <!-- 添加组按钮 -->
      <div class="clearfix">
        <div class="conditionRight">
          <div class="fc-button-group">
            <button
              type="button"
              class="btn btn-primary ml-1"
              v-if="reviewState == 1"
              @click="openAddGroupDialog('add', false)"
            >
              <i class="dripicons-plus mr-1"></i>
              <span>增加组</span>
            </button>
          </div>
        </div>
      </div>
      <!-- 分组表格 -->
      <table
        id="ktfz-datatable"
        class="table table-hover table-bordered table-centered table-proApp"
      >
        <thead>
          <tr>
            <th class="text-center">课题组名称</th>
            <th class="text-center">待评课题数</th>
            <th class="text-center">设置</th>
            <th class="text-center">操作</th>
          </tr>
        </thead>
        <tbody v-if="groupList.length">
          <tr v-for="(item, index) in groupList" :key="index">
            <td class="text-center">{{ item.name }}</td>
            <td class="text-center">
              {{ item.projectManagementId | getTopicNum }}
            </td>
            <td class="text-center">
              <span
                class="ml-1 mr-1"
                v-if="reviewState == 1"
                data-toggle="modal"
                data-target="#addTopic"
                @click="openAddTopicDialog('add', item)"
                >添加课题</span
              >
              <span
                class="ml-1 mr-1"
                v-if="reviewState == 1"
                data-toggle="modal"
                data-target="#remTopic"
                @click="openAddTopicDialog('del', item)"
                >移除课题</span
              >
              <span class="ml-1 mr-1" @click="openAddTopicDialog('view', item)"
                >查看</span
              >
            </td>
            <td class="text-center">
              <span
                v-if="reviewState == 1"
                class="ml-1 mr-1"
                data-toggle="modal"
                data-target="#groupName"
                @click="openAddGroupDialog('update', item)"
                >修改组名</span
              >
              <el-popconfirm
                title="确定删除该组吗？"
                @confirm="handleDelGroup(item)"
                ><span
                  v-if="reviewState == 1"
                  class="ml-1 mr-1"
                  slot="reference"
                  >删除组</span
                ></el-popconfirm
              >
            </td>
          </tr>
        </tbody>
      </table>
      <!-- 保存并下一步 -->
      <div class="text-center">
        <button
          type="button"
          class="btn btn-info"
          v-if="reviewState == 1"
          @click="submitGroupForm"
        >
          保存并下一步
        </button>
      </div>
    </div>

    <div class="topic_list" v-if="addOrDelTopicDialogVisible">
      <div class="topic_list_title">
        {{ `${addOrDelTopicDialogTitle}（当前组别：${modifiedData.name}）` }}
      </div>

      <el-form
        :inline="true"
        ref="addTopicDialogFilterFormRef"
        :model="addTopicDialogForm"
        label-width="80px"
      >
        <el-form-item label="课题名称">
          <el-input size="mini" v-model="addTopicDialogForm.name"></el-input>
        </el-form-item>
        <el-form-item label="课题类别">
          <el-cascader
            size="mini"
            v-model="addTopicDialogForm.projectTypeId"
            :options="topicTypeOptions"
            :props="{ value: 'id', label: 'name' }"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="学段">
          <el-select
            size="mini"
            v-model="addTopicDialogForm.learningType"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in learingTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学科">
          <el-select
            size="mini"
            v-model="addTopicDialogForm.disciplineId"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in disciplineOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="研究领域">
          <el-select
            size="mini"
            v-model="addTopicDialogForm.researchFieId"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in researchFieOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="立项年度">
          <el-date-picker
            size="mini"
            v-model="addTopicDialogForm.year"
            type="year"
            value-format="yyyy"
            placeholder="选择立项年度"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item
          v-if="$route.query.reviewType != 0"
          :label="getOpinionLabel"
        >
          <el-select
            size="mini"
            v-model="addTopicDialogForm.opinion"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in opinionOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="$route.query.reviewType != 0"
          :label="getScoreLabel"
        >
          <el-input
            size="mini"
            style="width: 50px"
            v-model="addTopicDialogForm.initialScoreStart"
          ></el-input>
          <span style="margin: 0 10px">~</span>
          <el-input
            size="mini"
            style="width: 50px"
            v-model="addTopicDialogForm.initialScoreEnd"
          ></el-input>
        </el-form-item>
        <el-form-item label=" " label-width="0px">
          <el-button type="primary" size="mini" @click="searchTopicList"
            >查询</el-button
          >
        </el-form-item>
      </el-form>

      <!-- 表格 -->
      <el-table
        :header-cell-style="tableStyle"
        v-loading="isTabelLoading"
        border
        ref="multipleTable"
        :data="topicList"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="mulSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="declareName" label="课题名称"></el-table-column>
        <el-table-column
          prop="projectTypeName"
          label="课题类别"
        ></el-table-column>
        <el-table-column
          prop="researchFieName"
          label="研究领域"
        ></el-table-column>
        <el-table-column prop="learningTypeName" label="学段"></el-table-column>
        <el-table-column prop="disciplineName" label="学科"></el-table-column>
        <el-table-column prop="oneUnitName" label="所属单位"></el-table-column>
        <el-table-column prop="oneEmceeName" label="负责人"></el-table-column>
        <el-table-column
          v-if="$route.query.reviewType == 1"
          prop="avgScore"
          label="初评得分"
        ></el-table-column>
        <el-table-column
          v-if="$route.query.reviewType == 1"
          prop="results"
          label="初评意见"
        ></el-table-column>
        <el-table-column
          v-if="$route.query.reviewType == 2"
          prop="avgScore"
          label="复评得分"
        ></el-table-column>
        <el-table-column
          v-if="$route.query.reviewType == 2"
          prop="results"
          label="复评意见"
        ></el-table-column>
        <el-table-column prop="createTime" label="申报时间">
          <template v-slot="scope">
            {{ scope.row.createTime | getTime }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="text-align: center; margin-top: 10px"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="addTopicDialogForm.pageNumber"
        :page-sizes="[10, 50, 100]"
        :page-size="addTopicDialogForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="topicTotal"
      ></el-pagination>
      <div class="btn_wrap">
        <el-button @click="addOrDelTopicDialogVisible = false">返 回</el-button>
        <el-button
          type="primary"
          v-if="addOrDelTopicDialogTitle !== '查看课题'"
          @click="addTopicToGroup"
          >{{ addOrDelTopicDialogTitle }}</el-button
        >
      </div>
    </div>

    <!-- 添加课题，修改组名 -->
    <el-dialog
      title="添加课题组"
      :visible.sync="groupNameDialogShow"
      :close-on-click-modal="false"
    >
      <el-form
        :model="addGroupForm"
        ref="addGroupFormRef"
        :rules="addGroupFormRules"
        label-width="80px"
      >
        <el-form-item label="组名称：" prop="name">
          <el-input v-model.trim="addGroupForm.name"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelUpdateGroup">取 消</el-button>
        <el-button type="primary" @click="addOrEditGroup">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 添加课题对话框 -->
    <!-- <el-dialog :title="addOrDelTopicDialogTitle" :visible.sync="addOrDelTopicDialogVisible" width="70%" :close-on-click-modal="false">
			<el-form :inline="true" ref="addTopicDialogFilterFormRef" :model="addTopicDialogForm" label-width="80px">
				<el-form-item label="课题名称"><el-input size="mini" v-model="addTopicDialogForm.name"></el-input></el-form-item>
				<el-form-item label="课题类别">
					<el-select size="mini" v-model="addTopicDialogForm.projectTypeId" clearable placeholder="请选择">
						<el-option v-for="item in topicTypeOptions" :key="item.id" :label="item.dictName" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="学段">
					<el-select size="mini" v-model="addTopicDialogForm.learningType" clearable placeholder="请选择">
						<el-option v-for="item in learingTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="学科">
					<el-select size="mini" v-model="addTopicDialogForm.disciplineId" clearable placeholder="请选择">
						<el-option v-for="item in disciplineOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="研究领域">
					<el-select size="mini" v-model="addTopicDialogForm.researchFieId" clearable placeholder="请选择">
						<el-option v-for="item in researchFieOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-if="$route.query.reviewType != 0" :label="getOpinionLabel">
					<el-select size="mini" v-model="addTopicDialogForm.opinion" clearable placeholder="请选择">
						<el-option v-for="item in opinionOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-if="$route.query.reviewType != 0" :label="getScoreLabel">
					<el-input size="mini" style="width: 50px;" v-model="addTopicDialogForm.initialScoreStart"></el-input>
					<span style="margin: 0 10px;">~</span>
					<el-input size="mini" style="width: 50px;" v-model="addTopicDialogForm.initialScoreEnd"></el-input>
				</el-form-item>
				<el-form-item><el-button type="primary" size="mini" @click="searchTopicList">查询</el-button></el-form-item>
			</el-form> -->

    <!-- 表格 -->
    <!-- <el-table v-loading="isTabelLoading" border ref="multipleTable" :data="topicList" tooltip-effect="dark" style="width: 100%" @selection-change="mulSelectionChange">
				<el-table-column type="selection" width="55"></el-table-column>
				<el-table-column prop="name" label="课题名称"></el-table-column>
				<el-table-column prop="projectTypeName" label="课题类别"></el-table-column>
				<el-table-column prop="researchFieName" label="研究领域"></el-table-column>
				<el-table-column prop="learningTypeName" label="学段"></el-table-column>
				<el-table-column prop="disciplineName" label="学科"></el-table-column>
				<el-table-column prop="unitName" label="所属单位"></el-table-column>
				<el-table-column prop="oneEmceeName" label="负责人"></el-table-column>
				<el-table-column v-if="$route.query.reviewType == 1" prop="internAvgScore" label="初评得分"></el-table-column>
				<el-table-column v-if="$route.query.reviewType == 1" prop="internResults" label="初评意见"></el-table-column>
				<el-table-column v-if="$route.query.reviewType == 2" prop="internAvgScore" label="复评得分"></el-table-column>
				<el-table-column v-if="$route.query.reviewType == 2" prop="reviewResults" label="复评意见"></el-table-column>
				<el-table-column prop="createTime" label="申报时间"></el-table-column>
			</el-table>
			<el-pagination
			style="text-align: center;margin-top: 10px;"
			      @size-change="handleSizeChange"
			      @current-change="handleCurrentChange"
			      :current-page="addTopicDialogForm.pageNumber"
			      :page-sizes="[10, 50, 100]"
			      :page-size="addTopicDialogForm.pageSize"
			      layout="total, sizes, prev, pager, next, jumper"
			      :total="topicTotal">
			    </el-pagination>

			<span slot="footer" class="dialog-footer">
				<el-button @click="addOrDelTopicDialogVisible = false">取 消</el-button>
				<el-button type="primary" v-if="addOrDelTopicDialogTitle !== '查看课题'" @click="addTopicToGroup">{{ addOrDelTopicDialogTitle }}</el-button>
			</span>
		</el-dialog> -->
  </div>
</template>

<script>
import {
  saveTopicGroup,
  delTopicGroupById,
  moveSubjectDeclare,
  getBaseInfoDetail,
  getExpertReviewGroupListByReviewId,
  getTopicManagementList,
} from "@/api/after/topicManage.js";
import { getPlatformInformationData } from "@/api/after/systemManagement.js";
export default {
  computed: {
    getOpinionLabel() {
      if (this.reviewBaseInfo) {
        if (this.reviewBaseInfo.reviewType == 1) {
          return "初评意见";
        } else if (this.reviewBaseInfo.reviewType == 2) {
          return "复评意见";
        }
      }
    },
    getScoreLabel() {
      if (this.reviewBaseInfo) {
        if (this.reviewBaseInfo.reviewType == 1) {
          return "初评得分";
        } else if (this.reviewBaseInfo.reviewType == 2) {
          return "复评得分";
        }
      }
    },
  },
  filters: {
    getTopicNum(val) {
      if (val) {
        return val.split(",").length;
      }
    },
  },
  data() {
    return {
      tableStyle: {
        textAlign: "center",
        backgroundColor: "#7e9be2",
        color: "#fff",
      },
      isTabelLoading: false,
      curOperate: "add",
      groupList: [], //分组列表
      groupNameDialogShow: false,
      // 添加课题分组
      addGroupForm: {
        name: "", //分组名称
      },
      addGroupFormRules: {
        name: [
          { required: true, message: "请输入分组名称！", trigger: "blur" },
        ],
      },
      groupTotal: 0,
      addOrDelTopicDialogVisible: false, // 控制添加分组对话框的显示和隐藏
      // 添加课题到分组-获取课题列表
      addTopicDialogForm: {
        name: "", //	课程名称
        projectTypeId: null, //课题类别id
        learningType: null, //	所属学段类型(0:幼儿园，1:小学,2:初中,3:高中,4:高/中职,5:其他)
        disciplineId: null, //	所属学科id
        researchFieId: null, //研究领域id
        ids: [], //	需要排除ID集合
        inIds: [], //需要查询的ID集合
        initialScoreEnd: "", //	初评分数结束分数
        initialScoreStart: "", //	初评分数开始分数
        // opinion: null, //	意见(0:不建议立项,1:建议立项)
        pageNumber: 1, //页码,默认为1,示例值(1)
        pageSize: 10, //页大小,默认为10,示例值(10)
        // projectId: null, //项目id
        reviewType: null, //审查状态(0:初审,1复审,2:终审)
        year: "", //立项年度
      },
      // 需要排除的课题ID列表
      ids: [],
      topicList: [], //课题列表
      topicTotal: 0, //课题总数
      // 课题类型
      topicTypeOptions: [],
      // 学段
      learingTypeOptions: [
        {
          value: 0,
          label: "幼儿园",
        },
        {
          value: 1,
          label: "小学",
        },
        {
          value: 2,
          label: "初中",
        },
        {
          value: 3,
          label: "高中",
        },
        {
          value: 4,
          label: "高/中职",
        },
        {
          value: 5,
          label: "其他",
        },
      ],
      // 学科
      disciplineOptions: [],
      //研究领域
      researchFieOptions: [],
      opinionOptions: [
        {
          value: 0,
          label: "不建议立项",
        },
        {
          value: 1,
          label: "建议立项",
        },
      ],
      // 多选课题
      mulSelectVal: [],
      // 添加或者移除课题对话框标题
      addOrDelTopicDialogTitle: "添加课题",
      reviewState: 0, //审核状态
      reviewBaseInfo: null, //基本信息
      modifiedData: null, //正在被操作的分组数据
    };
  },
  created() {
    this.getBaseInfoDetail();
    this.getExpertReviewGroupListByReviewId(this.$route.query.reviewId);
    // 获取筛选参数课题列表
    this.getTopicLevelTypeList();
    this.getResearchFieldData();
    this.getDisciplineData();
  },
  methods: {
    // 根据评审ID获取评审基本信息
    async getBaseInfoDetail() {
      const res = await getBaseInfoDetail(this.$route.query.reviewId);
      if (res.code == 200) {
        console.log("获取基本信息", res);
        this.reviewState = res.data.reviewState;
        this.reviewBaseInfo = res.data;
      } else {
        this.$message.error(res.data);
      }
    },

    // 根据评审ID获取课题分组
    async getExpertReviewGroupListByReviewId(id) {
      const res = await getExpertReviewGroupListByReviewId(id);
      if (res.code == 200) {
        console.log("获取课题分组", res);
        this.groupList = res.data;
      } else {
        this.$message.error(res.data);
      }
    },

    // --------------------------分组-------------------------
    //添加或者删除课题分组
    openAddGroupDialog(type, item) {
      console.log(type, item);
      this.curOperate = type;
      if (item) {
        this.modifiedData = item;
        this.addGroupForm.name = item.name;
      }
      this.groupNameDialogShow = true;
    },
    // 添加或者修改分组
    addOrEditGroup() {
      this.$refs.addGroupFormRef.validate((valid) => {
        if (valid) {
          let query = {
            name: this.addGroupForm.name,
            declareId: null,
          };
          if (this.curOperate == "update") {
            query.id = this.modifiedData.id;
            query.projectManagementId = this.modifiedData.projectManagementId;
          }
          this.updateTopicGroup(query);
          this.addGroupForm.name = "";
          this.groupNameDialogShow = false;
        }
      });
    },
    // 取消修改组名
    cancelUpdateGroup() {
      this.addGroupForm.name = "";
      this.groupNameDialogShow = false;
    },
    // 根据分组ID删除分组
    async handleDelGroup(data) {
      const res = await delTopicGroupById(data.id);
      if (res.code == 200) {
        this.$message.success("删除分组成功！");
        this.getExpertReviewGroupListByReviewId(this.$route.query.reviewId);
      } else {
        this.$message.error(res.data);
      }
    },
    // ----------------------------课题-------------------------------
    // 获取课题列表
    async getTopicManagementList(params) {
      this.isTabelLoading = true;
      const res = await getTopicManagementList(params);
      if (res.code == 200) {
        this.topicList = res.data.records;
        this.topicTotal = res.data.total;
        this.isTabelLoading = false;
      } else {
        this.$message.error(res.data);
      }
    },
    // 课题表格多选
    mulSelectionChange(val) {
      this.mulSelectVal = val;
    },
    // 打开课题列表
    openAddTopicDialog(type, item) {
      this.modifiedData = item;
      this.addTopicDialogForm.pageNumber = 1;
      this.addTopicDialogForm.pageSize = 10;
      console.log("正在被操作的分组", this.modifiedData);
      let form = JSON.parse(JSON.stringify(this.addTopicDialogForm));
      // form.projectId = +this.$route.query.projectId;
      form.reviewType = +this.reviewBaseInfo.reviewType;
      form.isView = null; // 是否查看
      if (type == "add") {
        form.ids = this.getAllSelectedTopicIdArr();
        form.inIds = [];
        this.getTopicManagementList(form);
        this.addOrDelTopicDialogTitle = `添加课题`;
        this.addOrDelTopicDialogVisible = true;
      } else {
        // 首先判断该分组是否有课题
        if (!this.modifiedData.projectManagementId) {
          this.$alert("还没有添加课题！请先添加课题！", "提示", {
            confirmButtonText: "确定",
            type: "warning",
          });
          return;
        }
        form.ids = [];
        form.inIds = this.modifiedData.projectManagementId.split(",");
        form.isView = 1; // 是否查看
        this.getTopicManagementList(form);
        this.addOrDelTopicDialogVisible = true;
        this.addOrDelTopicDialogTitle = type == "del" ? "移除课题" : "查看课题";
      }
      this.addTopicDialogForm = form; //修改20211126
    },
    // 查询课题列表
    searchTopicList() {
      this.addTopicDialogForm.pageNumber = 1;
      let form = JSON.parse(JSON.stringify(this.addTopicDialogForm));
      // form.projectId = +this.$route.query.projectId;
      if (
        form.projectTypeId !== "" &&
        form.projectTypeId !== null &&
        form.projectTypeId !== undefined
      ) {
        form.projectTypeId = form.projectTypeId[form.projectTypeId.length - 1];
      }

      form.reviewType = +this.reviewBaseInfo.reviewType;
      if (this.addOrDelTopicDialogTitle === "添加课题") {
        form.ids = this.getAllSelectedTopicIdArr();
        form.inIds = [];
        this.getTopicManagementList(form);
      } else {
        form.ids = [];
        form.inIds = this.modifiedData.projectManagementId
          ? this.modifiedData.projectManagementId.split(",")
          : [];
        form.isView = 1;
        this.getTopicManagementList(form);
      }
    },
    // 添加或者删除课题
    addTopicToGroup() {
      if (!this.mulSelectVal.length) return;
      if (this.addOrDelTopicDialogTitle === "添加课题") {
        let addedIds = this.mulSelectVal.map((item) => {
          return item.id;
        });
        let params = {
          name: this.modifiedData.name,
          projectManagementId: null,
          id: this.modifiedData.id,
        };
        params.projectManagementId = this.modifiedData.projectManagementId
          ? this.modifiedData.projectManagementId
              .split(",")
              .concat(addedIds)
              .join(",")
          : [].concat(addedIds).join(",");
        this.updateTopicGroup(params, "成功添加课题到该分组中！");
      } else if (this.addOrDelTopicDialogTitle === "移除课题") {
        let params = {
          declareId: [],
          groupId: this.$route.query.reviewId,
          groupInfoId: this.modifiedData.id,
        };
        params.declareId = this.mulSelectVal.map((item) => {
          return item.id;
        });
        this.delTopicInGroupByIds(params);
      }
      this.addOrDelTopicDialogVisible = false;
    },
    // 从分组中移除课题
    async delTopicInGroupByIds(params) {
      const res = await moveSubjectDeclare(params);
      if (res.code == 200) {
        this.modifiedData = null;
        this.$message.success("删除该分组中课题成功！");
        this.getExpertReviewGroupListByReviewId(this.$route.query.reviewId);
      } else {
        this.$message.error(res.data);
      }
    },

    //组和课题的添加修改
    async updateTopicGroup(data, tips) {
      console.log("分组参数", data);
      if (!data) return;
      let query = {
        managementSettingId: this.$route.query.reviewId,
        name: data.name,
        projectManagementId: data.projectManagementId
          ? data.projectManagementId
          : null, //课题id
        reviewType: this.reviewBaseInfo.reviewType,
        mark: false,
      };
      if (data.id) query.id = data.id;
      const res = await saveTopicGroup(query);
      if (res.code == 200) {
        this.modifiedData = null;
        tips && this.$message.success(tips);
        this.getExpertReviewGroupListByReviewId(this.$route.query.reviewId);
      } else {
        this.$message.error(res.data);
      }
    },
    // 保存并下一步
    async submitGroupForm() {
      let params = {
        groupId: this.$route.query.reviewId,
        mark: true,
      };
      const res = await saveTopicGroup(params);
      if (res.code == 200) {
        this.$emit("finish");
      } else {
        this.$message.error(res.data);
      }
    },
    // 根据项目ID获取课题类别
    // async getTopicCateById(id) {
    // 	const res = await getTopicCateById(id);
    // 	if (res.code == 200) {
    // 		console.log('课题类别', res);
    // 		this.topicTypeOptions = res.data;
    // 	} else {
    // 		this.$message.error(res.data);
    // 	}
    // },
    // 获取课题级别类别目录
    async getTopicLevelTypeList() {
      const res = await getPlatformInformationData(1);
      console.log("课题级别类别", res);
      if (res.code == 200) {
        this.topicTypeOptions = res.data;
      } else {
        this.$message.error(res.data);
      }
    },
    // 获取研究领域数据
    async getResearchFieldData() {
      const res = await getPlatformInformationData(6);
      if (res.code == 200) {
        console.log("领域", res);
        this.researchFieOptions = res.data;
      } else {
        this.$message.error(res.data);
      }
    },
    // 获取学科数据
    async getDisciplineData() {
      const res = await getPlatformInformationData(8);
      if (res.code == 200) {
        console.log("学科", res);
        this.disciplineOptions = res.data;
      } else {
        this.$message.error(res.data);
      }
    },
    handleSizeChange(val) {
      this.addTopicDialogForm.pageSize = val;
      console.log(this.addTopicDialogForm);
      let form = JSON.parse(JSON.stringify(this.addTopicDialogForm));
      if (
        form.projectTypeId !== "" &&
        form.projectTypeId !== null &&
        form.projectTypeId !== undefined
      ) {
        form.projectTypeId = form.projectTypeId[form.projectTypeId.length - 1];
      }
      console.log(form);
      // form.projectId = +this.$route.query.projectId;
      form.reviewType = +this.reviewBaseInfo.reviewType;
      this.getTopicManagementList(form);
    },
    handleCurrentChange(val) {
      this.addTopicDialogForm.pageNumber = val;
      let form = JSON.parse(JSON.stringify(this.addTopicDialogForm));
      if (
        form.projectTypeId !== "" &&
        form.projectTypeId !== null &&
        form.projectTypeId !== undefined
      ) {
        form.projectTypeId = form.projectTypeId[form.projectTypeId.length - 1];
      }
      // form.projectId = +this.$route.query.projectId;
      form.reviewType = +this.reviewBaseInfo.reviewType;
      this.getTopicManagementList(form);
    },
    // 获取所有已经被选择了的课题
    getAllSelectedTopicIdArr() {
      let allSelectedTopicIdArr = [];
      this.groupList.forEach((item) => {
        if (item.projectManagementId) {
          let curArr = item.projectManagementId.split(",");
          allSelectedTopicIdArr = allSelectedTopicIdArr.concat(curArr);
        }
      });
      return allSelectedTopicIdArr;
    },
  },
};
</script>

<style scoped lang="scss">
.topic_list {
  .topic_list_title {
    font-size: 24px;
    border-bottom: 1px solid #cccccc;
    line-height: 1.5;
  }
}

.btn_wrap {
  text-align: right;
}
</style>
